/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

import { Injectable } from '@angular/core';

@Injectable()
export class FeatureToggleService {
   private config = process.env.config;

   /**
    * 
    */
   constructor() {}

   /**
    * 
    * @param featureToggle 
    */
   isEnabled(featureToggle: string) {
      return this.config.feature[featureToggle];
   }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/feature-toggle.service.ts